import { Component, Input,  ElementRef } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-footer',
  templateUrl: './footer.component.html',
  host: {
    class: 'uex-card-footer card-footer'
  }
})
export class CardFooterComponent {
  @Input('alignItems') public alignItems = 'center';
  @Input('alignContent') public alignContent: string = null;
  @Input('justifyItems') public justifyItems: string = null;

  constructor(
    public elementRef: ElementRef
  ) { }
}
